<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>头像框配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="avatar_id" label="ID">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.avatar_id" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.name" />
            </template>
          </el-table-column>
          <el-table-column prop="guideType" label="类型">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="item in selectType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="active" label="状态">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.active" placeholder="请选择">
                <el-option
                  v-for="item in actType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="active" label="使用状态">
            <template v-slot:default="scope">
              <el-select v-model.number="scope.row.active" placeholder="请选择">
                <el-option
                  v-for="item in actType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="theme_id" label="背景ID">
            <template v-slot:default="scope">
              <el-input v-model.number="scope.row.theme_id" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120px">
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:avatarConfig:del']" type="danger" @click="del(scope.$index,scope.row.avatar_id,scope.row.created_at)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center">
          <el-button v-permisaction="['config:avatarConfig:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:avatarConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delAvatarCfg, getAvatarCfgList, updateAvatarCfg } from '@/api/config/avatar-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'AvatarConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      loading: false,
      selectType: [
        { label: '普通', value: 1 },
        { label: 'vip', value: 2 },
        { label: '限时卡组', value: 3 }
      ],
      actType: [
        { label: '未激活', value: 0 },
        { label: '已激活', value: 1 }
      ],
      formData: [{
        avatar_id: '0',
        name: '',
        active: 1,
        type: 1,
        theme_id: 0
      }]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.avatar_id <= 0) {
          this.msgError('头像ID小于等于0')
          return
        }
        if (!_data.name) {
          this.msgError('名称不能为空')
          return
        }
      }

      const data = JSON.stringify(this.formData)
      console.log('data', data)
      updateAvatarCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.$store.dispatch('app/clearLocalStorage', { key: 'getSieveAllList' })
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.loading = true
      const params = { ...this.queryParams }
      getAvatarCfgList(params).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        avatar_id: '0',
        name: '',
        active: 1,
        type: 1,
        theme_id: ''
      })
    },
    del(index, id, createTime = 0) {
      if (createTime > 0) {
        this.$confirm('你确定要删除该数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再看看',
          type: 'warning'
        }).then(() => {
          delAvatarCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.tableData = this.tableData.filter((item, idx) => {
          return idx !== index
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
